import { render, staticRenderFns } from "./aSquare.vue?vue&type=template&id=ab7519ec&scoped=true&"
import script from "./aSquare.vue?vue&type=script&lang=js&"
export * from "./aSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7519ec",
  null
  
)

export default component.exports